import { getLocale } from "../runtime";

const sv_notifyformemailplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `din@email.com`
};

const notifyformemailplaceholder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyformemailplaceholder(inputs)
	return "notifyFormEmailPlaceholder";
};

export { notifyformemailplaceholder as "notifyFormEmailPlaceholder" };